import {
    LitElement,
    html,
    css,
    unsafeHTML
} from "https://cdn.jsdelivr.net/gh/lit/dist@3/all/lit-all.min.js";
export class SkioPlanPicker extends LitElement {
    static properties = {
        key: {
            type: String
        },
        product: {
            type: Object
        },
        productHandle: {
            type: String
        },
        selectedVariant: {
            type: Object
        },
        options: {
            type: Object
        },
        moneyFormat: {
            type: String
        },
        quantity: {
            type: Number
        },
        rules: {
            type: Array
        },
        rule: {
            type: Object
        },
        cart: {
            type: Object
        },
        availableSellingPlanGroups: {
            state: !0
        },
        selectedSellingPlanGroup: {
            type: Object
        },
        selectedSellingPlan: {
            type: Object
        },
        disableUrl: {
            type: Boolean
        },
        debug: {
            type: Boolean
        },
        freeShippingAvailable: {
            type: Boolean
        },
    };
    static styles = [css`
      :host {
        width: 100%;
        max-width: 440px;
      }

      .skio-plan-picker {
        display: flex;
        gap: 1rem;
        padding: 0;
        border: 0;
        font-size: 15px;
        color: black;
        width: 100%;
        margin-bottom: 1rem;
        font-family: inherit;
      }

      .group-content-additional li:last-child::after {
        content: "";
        display: inline-block;
        width: 21px;
        height: 21px;
        background-image: url(//cdn.shopify.com/s/files/1/0975/7822/1898/files/bottle_front_6e7b38fe-9b9d-4eff-a6af-e530fa895ca4.webp?v=1765193992);
        background-size: contain;
        background-repeat: no-repeat;
        margin-left: 4px;
        vertical-align: top;    
        margin-top: -3px;
      }

      .group-container.orange .group-content-additional li:last-child::after {
        background-image: url(//cdn.shopify.com/s/files/1/0975/7822/1898/files/bottle_front_6e7b38fe-9b9d-4eff-a6af-e530fa895ca4.webp?v=1765193992);
      }

      :host([layout='hidden']) .skio-plan-picker {
        display: none;
      }

      :host([layout='vertical']) .skio-plan-picker {
        flex-direction: column;
      }

      :host([layout='horizontal']) .skio-plan-picker {
        flex-direction: row;
        flex-wrap: wrap;
      }

      .sr-only {
        position: absolute;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        border: 0;
      }

      .group-container {
        display: block;
        position: relative;
        transition: border-color 0.2s ease;
        border: var(--skio-group-border-width, 1px) solid var(--skio-group-border-color, #ccc);
        border-radius: var(--skio-group-border-radius, 0);
        background-color: var(--skio-group-background-color, transparent);
        color: var(--skio-group-text-color, #000);

        box-shadow: 0 0 5px rgba(23, 24, 24, 0.05), 0 1px 2px rgba(0, 0, 0, 0.07);
      }

      .group-container.hidden {
        display: none;
      }

      .group-container--selected {
        border-color: var(--skio-group-border-selected-color, #333);
        background-color: var(--skio-group-background-selected-color, transparent);
        color: var(--skio-group-text-selected-color, #000);
      }

      .group-container--last {
        order: 1;
      }

      :host([layout='horizontal']) .group-container {
        width: calc(50% - 0.5rem - calc(2 * var(--skio-group-border-width, 1px)));
      }

      .group-input {
        position: absolute;
        opacity: 0;
        width: 0px;
        height: 0px;
      }

     

      .group-label {
        display: flex;
        flex-direction: column;
        padding: 12px;
        cursor: pointer;
      }

      .group-topline {
        display: flex;
        align-items: flex-start;
        width: 100%;

        gap: 12px;
      }

      .group-container--selected .group-topline {
        font-weight: 700;
      }

      :host([layout='horizontal']) .group-topline {
        flex-direction: column;
        text-align: center;
      }

      .skio-radio__container { 
      }

      .skio-radio__container .ico-no-sel {
        display:block;
      }
      .skio-radio__container .ico-sel {
        display:none;
      }
      .group-container--selected .skio-radio__container {
        color: rgba(38, 30, 30, 0.75);
      }
      .group-container--selected .skio-radio__container .ico-no-sel {
        display:none;
      }
      .group-container--selected .skio-radio__container .ico-sel {
        display:block;
      }
      .skio-radio {
        transform-origin: center;
        opacity: 0;
        transform: scale(0);
        transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }

      .group-label:hover .skio-radio {
        opacity: 0.75;
        transform: scale(1);
      }

      .group-container--selected .group-label .skio-radio {
        opacity: 1;
        transform: scale(1);
      }
        .group-content-additional {
        margin: 12px 0;
        }
      .group-content-additional ul{
          list-style-type: none; 
      }
      .group-content-additional li {
        color: var(--Black, #000); 
        font-family: Athletics;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        position: relative;
        padding-left: 28px;
      }
      .group-content-additional li:before {
        content:'';
        background-image: url("data:image/svg+xml;utf8,<svg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M4.38309 8.92379C4.50448 8.87347 4.61476 8.79972 4.70762 8.70676L11.707 1.7078C11.7999 1.61491 11.8736 1.50462 11.9238 1.38325C11.9741 1.26187 12 1.13178 12 1.00041C12 0.869032 11.9741 0.738942 11.9238 0.617567C11.8736 0.496193 11.7999 0.385908 11.707 0.293012C11.6141 0.200115 11.5038 0.126426 11.3824 0.076151C11.261 0.0258758 11.1309 0 10.9995 0C10.8682 0 10.7381 0.0258758 10.6167 0.076151C10.4953 0.126426 10.385 0.200115 10.2921 0.293012L4.00019 6.58582L1.7079 4.29242C1.52028 4.1048 1.2658 3.9994 1.00046 3.9994C0.735124 3.9994 0.480652 4.1048 0.293028 4.29242C0.105405 4.48003 0 4.73449 0 4.99981C0 5.26513 0.105405 5.51959 0.293028 5.70721L3.29275 8.70676C3.38562 8.79972 3.49589 8.87347 3.61728 8.92379C3.73867 8.9741 3.86878 9 4.00019 9C4.13159 9 4.2617 8.9741 4.38309 8.92379Z' fill='%2348B8CF'/></svg>");
        width: 20px;
        height: 20px;
        aspect-ratio: 1 / 1;
        position: absolute;
        background-repeat: no-repeat;
        left: 0;
        top: 0;
        background-position: center;

      }
      .skio-price {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        text-align: right;
        gap: 4px;

        line-height: 1;

        margin-left: auto;
        vertical-align: middle;

        font-weight: 500;
      }
      .skio-price {
        text-align: center; 
        font-family: "Bebas Kai";
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
      }
      .skio-price s {
        
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        color: var(--Grey-800, #939393);
        text-decoration-line: line-through;
      }

      :host([layout='horizontal']) .skio-price {
        text-align: center;
        margin-right: auto;
        font-family: "Bebas Kai";
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
      }

      .group-content {
        display: flex;
        flex-direction: column;
        opacity: 1;
        width: auto;
        max-height: 1000px;
        transition: max-height 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      }
 

      .group-content p {
        margin: 0.5rem 0 0 0;
        font-size: 13px;
        color: #000;
      }

      :host([layout='horizontal']) .group-content {
        width: 100%;
      }

      /* Hide frequency if not selected */
      .group-container:not(.group-container--selected) .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      }

      :host([layout='horizontal']) .group-container:not(.group-container--selected) + .group-content {
        pointer-events: none;
        opacity: 0;
        max-height: 0;
        visibility: hidden;
      }

      .group-title {
        width: 100%;
        max-width: 70%;
        font-family: "Bebas Kai";
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; 
        display: flex;
        align-items: center;
        gap: 10px;
      }

      :host([layout='horizontal']) .group-title {
        max-width: 100%;
      }

      .savings {
        color: var(--skio-discount-text-color, #fff);
      }

      .savings.bubble {
         color: var(--White, #FFF); 
        font-family: Athletics;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
        border-radius: 4px;
        background: var(--Blue-Blue-700, #48B8CF);
        display: flex;
        padding: 3px 8px 2px 8px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        white-space: nowrap;
      }

     
      .selling-plan-dropdown {
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none; 
          align-items: center;
          gap: 5px;
          width: 100%;
          margin-top: 5px;
          padding: 8px 30px 8px 10px;
          background-color: transparent;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
              background-repeat: no-repeat;
          background-position: right 10px top 50%;
          background-size: 16px;
          border: 1px solid #ccc;
          border-radius: 5px;
          font-size: 14px;
          text-overflow: ellipsis;
          white-space: nowrap;
          border-radius: 6px;
          border: 0.5px solid var(--Grey-700, #C9C9C9);
          /* background: var(--Grey-400, #F4F4F4); */
          display: flex;
          padding: 11px 12px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          align-self: stretch;
          margin: 0;
          height: 45px;
          font-family: Athletics;
          font-size: 15px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; 
          outline: none;
          box-shadow: none;
          display: none;

      }
      .selling-plan-dropdown-label {
        color: #666666;
        font-weight: 500;
      }

      .selling-plan-dropdown--one {
        background-image: none;
        pointer-events: none;
        background: transparent;
      }

      .selling-plan-buttons {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(var(--skio-button-plan-selector-width, 20px), 1fr));
        gap: 10px;
        padding: 0.75rem 0;
        border: 0;
        font-size: 13px;
      }

      .selling-plan-buttons input[type='radio'] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
      }

      .selling-plan-buttons label {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 1px solid #ccc;
        text-align: center;
        padding: 1rem 0.5rem;
      }

      .selling-plan-buttons input[type='radio']:checked + label {
        border-color: #000;
      }

      .selling-plan-buttons input:focus-visible + label {
        outline: 2px #ccc solid;
        outline-offset: 4px;
      }
 
      .hr {
        border-bottom: 0.5px solid var(--Grey-600, #DFDFDF);
        width: calc(100% + 24px);
        margin-left: -12px;
        margin-top: 10px;
      }
      .group-content-additional ul {
        margin: 0;
        padding: 0;    
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .skio-details {
        --text-color: #333;
        --text-color-secondary: #888;

        user-select: none;
        -webkit-user-select: none;
        margin-bottom: 20px;
        order: 3;
        max-width: max-content;
      }

      .skio-details summary::-webkit-details-marker,
      .skio-details summary::marker,
      .skio-details slot {
        color: rgba(0, 0, 0, 0) !important;
      }

      .skio-details summary {
        margin-top: 15px;
      }

      .skio-details summary span {
        font-size: 0.9em;
        display: flex;
        padding: 0.5em 0;
        cursor: pointer;
        align-items: center;
        gap: 10px;
        text-decoration: underline;

        margin-top: -40px;
        color: #000;
      }

      @keyframes fadeInDown {
        0% {
          opacity: 0;
          transform: translateY(-15px);
        }
        100% {
          opacity: 1;
          transform: translateY(0px);
        }
      }
      .skio-details[open] > .skio-details--content {
        animation-name: fadeInDown;
        animation-duration: 0.3s;
      }

      .skio-details--content {
        position: absolute;
        z-index: 1020;
        padding: 1em;
        width: fit-content;
        border-radius: 5px;
        background: white;
        box-shadow: 0 0 5px rgb(23 24 24 / 5%), 0 1px 2px rgb(0 0 0 / 7%);
      }

      .skio-details ul {
        margin: 0;
        padding: 0;
      }

      .skio-details ul li {
        display: flex;
        align-items: flex-start;
        gap: 0.75em;

        margin-bottom: 1em;
      }

      .skio-details .skio-content {
        display: flex;
        flex-direction: column;
      }

      .skio-details .skio-content p {
        font-size: 0.9em;

        margin-top: 0;
        margin-bottom: 0;

        letter-spacing: 0;
        line-height: 1.5;

        color: var(--text-color);
      }

      .skio-details ul li small {
        font-size: 0.7em;
        color: var(--text-color-secondary);
      }

      .skio-details .skio-icon {
        display: flex;

        width: 2.25em;
        height: 2.25em;

        color: var(--text-color);
        background: #f8f8f8;
        border-radius: 100%;

        flex-shrink: 0;
        align-items: center;
        justify-content: center;
      }

      .skio-details .skio-icon svg {
        width: 1.25em;
        height: 1.25em;

        color: inherit;
      }

      .skio-details--footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.9em;
      }

      .skio-details--footer a {
        color: var(--text-color);
      }

      .skio-manage-link {
        text-decoration: underline;
      }

      .powered-by-skio {
        font-size: 0.8em;

        display: flex;
        text-decoration: none;

        align-items: center;
        gap: 3px;
      }

      .setupMode {
        position: relative;
        color: black;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-bottom: 1rem;
        font-size: 14px;
        border-style: solid;
        border-width: 4px;
        border-image: repeating-linear-gradient(-55deg, #000, #000 20px, #ffb101 20px, #ffb101 40px) 10;
      }

      .setupMode:after {
        content: 'Setup Mode';
        position: absolute;
        top: 0;
        right: 0;
        background-color: black;
        color: white;
        padding: 0.25rem 1rem;
        font-size: 13px;
      }

      .setupMode .detection {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 10px;
      }

      .setupMode .detection small {
        grid-column: 1/-1;
      }

      /* Custom CSS for Drink Sult */
      .group-topline-rows-wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      .group-topline-first-row,
      .group-topline-second-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      
      .group-subtitle, .price-per-serving {
        color: var(--Black, #000); 
        font-family: Athletics;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
      }
        
      @media (max-width: 1120px) {
        .skio-radio__container svg{
          width: 20px;
          height: 20px;
        }

        .group-title {
          font-size: 20px;
        }
        .savings.bubble {
          font-size: 12px;
        }
        .skio-price, .skio-price s {
            font-size: 18px; 
            line-height: 22px;
        }
      }

        @media (max-width: 900px) {
          .group-content-additional li {
            font-size: 14px; 
            line-height: 18px; 
          }
          .group-title {
            font-size: 20px; 
            line-height: 20px;
            max-width: 84%;
          }
          .savings.bubble {
            font-size: 12px; 
            line-height: 16px;
            padding: 3px 4px 2px 4px;
          }
          .skio-price, .skio-price s { 
            font-size: 20px; 
            line-height: 20px;
          }
          @media (max-width: 440px) {
            .group-title {
                font-size: 18px;
                line-height: 18px; 
            }
            .savings.bubble {
              font-size: 8px;
              line-height: 11px;
              padding: 3px 4px 2px 4px;
            }
            .group-topline { 
                gap: 8px;
            }
            .skio-price, .skio-price s {
                font-size: 18px;
                line-height: 18px;
            }
            .group-title {
               font-size: 16px;
               line-height: 16px;
               max-width: 84%;
               gap: 5px;
            }
            .group-content-additional {
                margin: 9px 0 0;
            }
          }
        }
    `];
    constructor() {
        super(), this.debug = this.debug || window?.Shopify?.designMode, this.variantChanged = !1, this.rules = [], this.rule = null, this.quantity = 1, this.showDetailsHover = !1
    }
    async connectedCallback() {
        super.connectedCallback(), this.log("Mounted"), this.productHandle && (this.loading = !0, this.fetchProduct(this.productHandle)), this.bindFormEvents(), this.bindCartEvents(), this.rules = await this.fetchRules(), await this.getRule()
        this.fetchFreeShippingStatus();
      }
    async fetchFreeShippingStatus() {
      // document.addEventListener("DOMContentLoaded", () => {
      //   const params = new URLSearchParams(window.location.search);
      //   const discount = params.get("discount");
      //   if(discount) {
      //     document.cookie = `utm_discount=${discount}; path=/; max-age=${60*60*24}`; 
      //   }
      // });
       window.location.href.includes('?firstbox') || window.location.href.includes('?launchparty') || window.location.href.includes('?sublaunch') ? this.freeShippingAvailable = true : this.freeShippingAvailable =false;
    }
    radioTemplate() {
        return html`
      <div class="skio-radio__container">
        <svg class="ico-no-sel" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" fill="white"/>
          <rect x="0.5" y="0.5" width="25" height="25" rx="12.5" stroke="#C9C9C9"/>
        </svg> 
        <svg class="ico-sel" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="26" height="26" rx="13" fill="#33ACC5"/>
          <path d="M11.3831 17.4238C11.5045 17.3735 11.6148 17.2997 11.7076 17.2068L18.707 10.2078C18.7999 10.1149 18.8736 10.0046 18.9238 9.88325C18.9741 9.76187 19 9.63178 19 9.50041C19 9.36903 18.9741 9.23894 18.9238 9.11757C18.8736 8.99619 18.7999 8.88591 18.707 8.79301C18.6141 8.70012 18.5038 8.62643 18.3824 8.57615C18.261 8.52588 18.1309 8.5 17.9995 8.5C17.8682 8.5 17.7381 8.52588 17.6167 8.57615C17.4953 8.62643 17.385 8.70012 17.2921 8.79301L11.0002 15.0858L8.7079 12.7924C8.52028 12.6048 8.2658 12.4994 8.00046 12.4994C7.73512 12.4994 7.48065 12.6048 7.29303 12.7924C7.10541 12.98 7 13.2345 7 13.4998C7 13.7651 7.10541 14.0196 7.29303 14.2072L10.2928 17.2068C10.3856 17.2997 10.4959 17.3735 10.6173 17.4238C10.7387 17.4741 10.8688 17.5 11.0002 17.5C11.1316 17.5 11.2617 17.4741 11.3831 17.4238Z" fill="white"/>
        </svg> 
      </div>
    `
    }
    sellingPlanDropdown(group) {
        return html`
      <select
        class="selling-plan-dropdown ${this.getAvailableSellingPlans(group).length==1?"selling-plan-dropdown--one":""}"
        @change=${e=>{this.selectSellingPlan(e.target.value)}}
      >
        ${group?this.getAvailableSellingPlans(group).map(selling_plan=>html` <option ?selected=${group.selected_selling_plan.id===selling_plan.id} value=${selling_plan.id}>${selling_plan.name}</option> `):""}
      </select>
    `
    }
    sellingPlanButtons(group) {
        return html`
      <fieldset class="selling-plan-buttons">
        <legend class="sr-only">Select subscription interval</legend>
        ${group?this.getAvailableSellingPlans(group).map(selling_plan=>html`
                <input
                  type="radio"
                  name="selling_plan_button"
                  value="${selling_plan}"
                  id="selling_plan_button-${selling_plan.id}"
                  @change="${e=>this.selectSellingPlan(selling_plan.id)}"
                  ?checked=${group.selected_selling_plan===selling_plan}
                />

                <label for="selling_plan_button-${selling_plan.id}"> ${selling_plan.name} </label>
              `):""}
      </fieldset>
    `
    }
    invalidIcon() {
        return html`
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#D22B2B" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    `
    }
    validIcon() {
        return html`
      <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#0BDA51" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    `
    }
    setupMode() {
        return html`
      <div class="setupMode">
        Skio Plan Picker
        <small>This will not appear on the live site.</small>

        <small>Key: ${this.key}</small>

        <div class="detection">${this.product?this.validIcon():this.invalidIcon()} Product</div>

        <div class="detection">${this.selectedVariant?this.validIcon():this.invalidIcon()} Selected Variant</div>

        <div class="detection">${this.form?this.validIcon():this.invalidIcon()} Form</div>

        <div class="detection">${this.variantInput?this.validIcon():this.invalidIcon()} Variant Input</div>

        <div class="detection">
          ${this.variantChanged?this.validIcon():this.invalidIcon()} Variant Change Detection
          <small>Please attempt to change the selected variant.</small>
        </div>

        <small>If any of these don't pass please troubleshoot using our <a target="_blank" rel="noreferrer" href="https://integrate.skio.com/troubleshooting">troubleshooting guide</a>.</small>
      </div>
    `
    }
    groupContent(group) {
        return html`
        
      <div class="group-content ${this.options?.layout=="horizontal"?"":this.options?.show_radio_selector&&this.options?.dropdownPosition=="inside"?"margin-left":""}">
        <div class="hr"> </div>
        ${this.options?.selector_type=="button"?this.sellingPlanButtons(group):""} ${this.additionalContentText()}
        
        <span class="selling-plan-dropdown-label">${this.additionalFrequencyLabel()}</span>
        ${this.options?.selector_type=="dropdown"?this.sellingPlanDropdown(group):""}

      </div>
    `
    }
    showDetails() {
        return html`
      <details class="skio-details" @mouseover=${e=>this.detailsMouseover()} @mouseleave=${e=>this.detailsMouseleave()}>
        <summary>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="ai ai-ArrowRepeat"
            >
              <path d="M18 2l3 3-3 3" />
              <path d="M6 22l-3-3 3-3" />
              <path d="M21 5H10a7 7 0 0 0-7 7" />
              <path d="M3 19h11a7 7 0 0 0 7-7" />
            </svg>

            How do subscriptions work?
          </span>
        </summary>
        <div class="skio-details--content">
          <ul>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <div class="skio-content">
                <p>Get exclusive deals</p>
                <small>Subscribe for unique discounts</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                </svg>
              </div>
              <div class="skio-content">
                <p>Edit your subscription anytime</p>
                <small>Edit products, delivery schedule and more</small>
              </div>
            </li>
            <li>
              <div class="skio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>

              <div class="skio-content">
                <p>No commitment</p>
                <small>Easy to cancel if it’s not for you</small>
              </div>
            </li>
          </ul>
          <div class="skio-details--footer">
            <a class="skio-manage-link" href="/a/account/login">Manage subscriptions</a>

            <a style="letter-spacing: 0" class="powered-by-skio" href="https://skio.com/?utm_source=eonsincshop.myshopify.com&utm_medium=details_popover" target="_blank" rel="noopener">
              Powered by
              <svg width="24" height="11" viewBox="0 0 24 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.28399 5.78801C4.12399 5.63601 3.93599 5.50801 3.71999 5.40401C3.50399 5.30001 3.27599 5.24801 3.03599 5.24801C2.85199 5.24801 2.67999 5.28401 2.51999 5.35601C2.36799 5.42801 2.29199 5.55201 2.29199 5.72801C2.29199 5.89601 2.37599 6.01601 2.54399 6.08801C2.71999 6.16001 2.99999 6.24001 3.38399 6.32801C3.60799 6.37601 3.83199 6.44401 4.05599 6.53201C4.28799 6.62001 4.49599 6.73601 4.67999 6.88001C4.86399 7.02401 5.01199 7.20001 5.12399 7.40801C5.23599 7.61601 5.29199 7.86401 5.29199 8.15201C5.29199 8.52801 5.21599 8.84801 5.06399 9.11201C4.91199 9.36801 4.71199 9.57601 4.46399 9.73601C4.22399 9.89601 3.95199 10.012 3.64799 10.084C3.34399 10.156 3.03999 10.192 2.73599 10.192C2.24799 10.192 1.76799 10.116 1.29599 9.96401C0.831989 9.80401 0.443989 9.57201 0.131989 9.26801L1.23599 8.10401C1.41199 8.29601 1.62799 8.45601 1.88399 8.58401C2.13999 8.71201 2.41199 8.77601 2.69999 8.77601C2.85999 8.77601 3.01599 8.74001 3.16799 8.66801C3.32799 8.58801 3.40799 8.45201 3.40799 8.26001C3.40799 8.07601 3.31199 7.94001 3.11999 7.85201C2.92799 7.76401 2.62799 7.67201 2.21999 7.57601C2.01199 7.52801 1.80399 7.46401 1.59599 7.38401C1.38799 7.30401 1.19999 7.19601 1.03199 7.06001C0.871989 6.92401 0.739989 6.75601 0.635989 6.55601C0.531989 6.35601 0.479989 6.11601 0.479989 5.83601C0.479989 5.47601 0.555989 5.17201 0.707989 4.92401C0.859989 4.66801 1.05599 4.46001 1.29599 4.30001C1.53599 4.14001 1.79999 4.02401 2.08799 3.95201C2.38399 3.87201 2.67599 3.83201 2.96399 3.83201C3.41199 3.83201 3.84799 3.90401 4.27199 4.04801C4.70399 4.18401 5.06799 4.39201 5.36399 4.67201L4.28399 5.78801Z"
                  fill="black"
                />
                <path d="M12.8481 10H10.4121L8.45615 7.13201H8.42015V10H6.44015V0.928009H8.42015V6.44801H8.45615L10.3641 4.02401H12.7521L10.4481 6.72401L12.8481 10Z" fill="black" />
                <path
                  d="M15.7009 2.11601C15.7009 2.26801 15.6689 2.41201 15.6049 2.54801C15.5489 2.67601 15.4689 2.78801 15.3649 2.88401C15.2689 2.98001 15.1489 3.05601 15.0049 3.11201C14.8689 3.16801 14.7249 3.19601 14.5729 3.19601C14.2529 3.19601 13.9849 3.09201 13.7689 2.88401C13.5529 2.66801 13.4449 2.41201 13.4449 2.11601C13.4449 1.97201 13.4729 1.83601 13.5289 1.70801C13.5849 1.57201 13.6649 1.45601 13.7689 1.36001C13.8729 1.26401 13.9929 1.18801 14.1289 1.13201C14.2649 1.06801 14.4129 1.03601 14.5729 1.03601C14.7249 1.03601 14.8689 1.06401 15.0049 1.12001C15.1489 1.17601 15.2689 1.25201 15.3649 1.34801C15.4689 1.44401 15.5489 1.56001 15.6049 1.69601C15.6689 1.82401 15.7009 1.96401 15.7009 2.11601ZM13.5889 10V4.02401H15.5569V10H13.5889Z"
                  fill="black"
                />
                <path
                  d="M23.4516 6.98801C23.4516 7.47601 23.3636 7.92001 23.1876 8.32001C23.0116 8.71201 22.7716 9.04801 22.4676 9.32801C22.1636 9.60001 21.8116 9.81201 21.4116 9.96401C21.0116 10.116 20.5836 10.192 20.1276 10.192C19.6796 10.192 19.2516 10.116 18.8436 9.96401C18.4436 9.81201 18.0916 9.60001 17.7876 9.32801C17.4916 9.04801 17.2556 8.71201 17.0796 8.32001C16.9036 7.92001 16.8156 7.47601 16.8156 6.98801C16.8156 6.50001 16.9036 6.06001 17.0796 5.66801C17.2556 5.27601 17.4916 4.94401 17.7876 4.67201C18.0916 4.40001 18.4436 4.19201 18.8436 4.04801C19.2516 3.90401 19.6796 3.83201 20.1276 3.83201C20.5836 3.83201 21.0116 3.90401 21.4116 4.04801C21.8116 4.19201 22.1636 4.40001 22.4676 4.67201C22.7716 4.94401 23.0116 5.27601 23.1876 5.66801C23.3636 6.06001 23.4516 6.50001 23.4516 6.98801ZM21.5556 6.98801C21.5556 6.79601 21.5236 6.60801 21.4596 6.42401C21.3956 6.24001 21.3036 6.08001 21.1836 5.94401C21.0636 5.80001 20.9156 5.68401 20.7396 5.59601C20.5636 5.50801 20.3596 5.46401 20.1276 5.46401C19.8956 5.46401 19.6916 5.50801 19.5156 5.59601C19.3396 5.68401 19.1916 5.80001 19.0716 5.94401C18.9596 6.08001 18.8716 6.24001 18.8076 6.42401C18.7516 6.60801 18.7236 6.79601 18.7236 6.98801C18.7236 7.18001 18.7516 7.36801 18.8076 7.55201C18.8716 7.73601 18.9636 7.90401 19.0836 8.05601C19.2036 8.20001 19.3516 8.31601 19.5276 8.40401C19.7036 8.49201 19.9076 8.53601 20.1396 8.53601C20.3716 8.53601 20.5756 8.49201 20.7516 8.40401C20.9276 8.31601 21.0756 8.20001 21.1956 8.05601C21.3156 7.90401 21.4036 7.73601 21.4596 7.55201C21.5236 7.36801 21.5556 7.18001 21.5556 6.98801Z"
                  fill="black"
                />
              </svg>
            </a>
          </div>
        </div>
      </details>
    `
    }
    render() {
      return !this.viable() || this.options?.layout === "hidden" ? this.debug ? this.setupMode() : "" : this.selectedVariant.selling_plan_allocations.length === 0 && !this.options?.show_without_subscription ? this.debug ? this.setupMode() : "" : html`
      ${this.debug?this.setupMode():null}
      <fieldset class="skio-plan-picker" role="radiogroup" aria-labelledby="skio-plan-picker-legend">
        <legend id="skio-plan-picker-legend" class="${this.options?.show_legend?"":"sr-only"}">${unsafeHTML(this.options?.legend_content)}</legend>
        ${this.product.requires_selling_plan?"": true ?
           html`
              <div
                class="group-container ${this.selectedSellingPlanGroup==null?"group-container--selected":""} ${this.options?.onetime_first?"":"group-container--last"} ${this.options?.hide_one_time_purchase === 'true' ?"hidden":""} ${this.options?.product_handle.includes('orange')?"orange":""}"
                @click=${()=>this.selectSellingPlanGroup(null)}
              >
                <input
                  id="one-time-${this.key}"
                  class="group-input"
                  name="skio-group-${this.key}"
                  type="radio"
                  value="One time purchase"
                  ?checked=${!this.selectedSellingPlanGroup}
                  @change=${()=>this.selectSellingPlanGroup(null)}
                />

                <label class="group-label" for="one-time-${this.key}">
                  <div class="group-topline">
                    ${this.options?.layout=="horizontal"?"":this.options?.show_radio_selector?this.radioTemplate():""}

                    <div class="group-topline-rows-wrapper">
                      <div class="group-topline-first-row">
                        <div class="group-title">${this.options?.onetime_title?this.options?.onetime_title:"One time"}</div>

                        <div class="skio-price" aria-live="polite">
                          ${this.options?.show_compare_price&&this.selectedVariant?.compare_at_price>this.selectedVariant.price?html`<s aria-hidden="true">${this.money(this.selectedVariant.compare_at_price)}</s>`:""}
                          ${this.money(this.selectedVariant.price)}
                        </div>
                      </div>

                      <div class="group-topline-second-row">
                        <div class="group-subtitle">${this.options?.onetime_subtitle?this.options?.onetime_subtitle:"30 servings"}</div>

                        <div class="price-per-serving" aria-live="polite">${this.options?.onetime_price_per_serving?this.options?.onetime_price_per_serving:"\xA30.99 per sachet"}</div>
                      </div>
                    </div>
                  </div>
                </label>
              </div>
            ` : ''
        }

            
        ${this.availableSellingPlanGroups?.length?this.availableSellingPlanGroups.map((group,index)=>html`
                <div class="group-container ${this.selectedSellingPlanGroup==group?"group-container--selected":""} ${this.options?.product_handle.includes('orange')?"orange":""}">
                  <input
                    id="group-${index}-${this.key}"
                    class="group-input"
                    name="skio-group-${this.key}"
                    type="radio"
                    value="${group.id}"
                    @change=${()=>this.selectSellingPlanGroup(group)}
                    ?checked=${this.selectedSellingPlanGroup==group}
                  />

                  <label class="group-label" for="group-${index}-${this.key}">
                    <div class="group-topline">
                      ${this.options?.layout=="horizontal"?"":this.options?.show_radio_selector?this.radioTemplate():""}

                      <div class="group-topline-rows-wrapper">
                        <div class="group-topline-first-row">
                          <div class="group-title">
                            ${group.name!=="Prepaid"&&this.options?.subscription_title?this.options?.subscription_title === 'Subscribe'?'Monthly Subscription':this.options?.subscription_title:group.name=="Prepaid"&&this.options?.prepaid_title?this.options?.prepaid_title:group.name}
                            ${window.location.href.includes('?firstbox') ? html`<span class="savings bubble">Save £15</span` :window.location.href.includes('?sublaunch') ? html`<span class="savings bubble">LAUNCH OFFER</span` : this.discountText(group.selected_selling_plan)?html` <span class="savings ${this.options?.discount_style}"> ${this.freeShippingAvailable ? 'ON THE HOUSE' :'SAVE 33%'} </span> `:html``}
                          </div>

                          <div class="skio-price" aria-live="polite">
${window.location.href.includes('?firstbox') || window.location.href.includes('?sublaunch') || window.location.href.includes('?launchparty') ? html`<s aria-hidden="true">${this.money((this.price(group.selected_selling_plan,!1)))}` : ""}
                            ${window.location.href.includes('?firstbox') ? this.money(this.price(group.selected_selling_plan,!1) - 2000) : window.location.href.includes('?sublaunch') || window.location.href.includes('?launchparty') ? window.location.href.includes('?launchparty') ? "Free" : this.money(this.price(group.selected_selling_plan,!1) - 2000) : this.money(this.price(group.selected_selling_plan,!1) - 0)}
                          </div>
                        </div>

                        <div class="group-topline-second-row">
                          <div class="group-subtitle">${this.options?.subscription_subtitle?this.options?.subscription_subtitle:"30 servings"}</div>

                          <div class="price-per-serving" aria-live="polite">${window.location.href.includes('?sublaunch')
  ? "Then " + this.money((this.price(group.selected_selling_plan,!1))) + "/mo"
  : this.options?.subscription_price_per_serving
    ? this.freeShippingAvailable
      ? '66p per serving'
      : '66p per serving'
    : "\xA30.86 per sachet"}</div>
                        </div>
                      </div>
                    </div>

                    ${this.options?.layout=="vertical"&&this.options?.dropdownPosition=="inside"?this.groupContent(group):""}
                  </label>
                </div>
                ${this.selectedSellingPlanGroup==group&&(this.options?.layout=="horizontal"||this.options?.dropdownPosition=="underneath")?this.groupContent(group):""}
              `):""}
        ${this.options?.show_details==!0?this.showDetails():""}
      </fieldset>
    `
    }
    async fetchRules() {
        if (sessionStorage.getItem("skio-discount-rules")) return JSON.parse(sessionStorage.getItem("skio-discount-rules"));
        {
            const rules = await fetch(`https://api.skio.com/storefront-http/get-rules-by-domain-or-hostname?domain=${window?.Shopify?.shop}`).then(response => response.json()).then(response => response.rules.filter(rule => rule.type !== "surpriseDelight").sort((a, b) => a.minQuantityToDiscount - b.minQuantityToDiscount));
            return sessionStorage.setItem("skio-discount-rules", JSON.stringify(rules)), rules
        }
    }
    eligibleItemCount(rule) {
        const eligibleQuantity = rule?.productVariantIds.some(gid => gid.includes(this.selectedVariant.id)) ? this.quantity : 0;
        return this.cart?.items ? Number(this.cart?.items.reduce((aggregate, item) => rule?.productVariantIds.some(gid => gid.includes(item.id) && item.selling_plan_allocation && gid.includes(this.selectedVariant.id)) ? aggregate + item.quantity : aggregate, 0)) + eligibleQuantity : eligibleQuantity
    }
    getRule() {
        let largestMinQuantity = {
            value: -1,
            index: -1
        };
        this.rules.forEach((rule, index) => {
            rule.code && largestMinQuantity.value < rule.minQuantityToDiscount && rule.minQuantityToDiscount <= this.eligibleItemCount(rule) && (largestMinQuantity.value = rule.minQuantityToDiscount, largestMinQuantity.index = index)
        }), this.rule = largestMinQuantity.index > -1 ? this.rules[largestMinQuantity.index] : null
    }
    bindCartEvents() {
        document.addEventListener("CartUpdated", event => {
            this.cart = event.detail
        })
    }
    bindFormEvents() {
        if (this.form = document.querySelector(`#${this.options?.form_id}`) || this.closest('form[action*="/cart/add"]'), !this.form) return;
        this.variantInput = this.form.querySelector('[name="id"]'), this.variantInput && this.variantInput.addEventListener("change", e => {
            this.selectedVariant = this.product.variants.find(variant => variant.id == e.target.value), this.variantChanged = !0
        });
        const $quantityInput = this.form.querySelector('[name="quantity"]');
        $quantityInput && (this.quantity = Number($quantityInput.value), $quantityInput.addEventListener("input", () => {
            this.quantity = Number($quantityInput.value)
        }))
    }
    detailsMouseover() {
        let details = this.renderRoot.querySelector(".skio-details"),
            summary = this.renderRoot.querySelector(".skio-details summary");
        !details.hasAttribute("open") && this.showDetailsHover == !1 && (summary.click(), this.showDetailsHover = !0)
    }
    detailsMouseleave() {
        let details = this.renderRoot.querySelector(".skio-details"),
            summary = this.renderRoot.querySelector(".skio-details summary");
        details.hasAttribute("open") && this.showDetailsHover == !0 && (summary.click(), this.showDetailsHover = !1)
    }
    updated(changed) {
        if (this.viable()) {
            if (changed.has("product") && this.product && (this.key = this.key ? this.key : this.product.id), changed.has("selectedVariant") && this.selectedVariant) {
                const filteredSellingPlanGroups = this.product.selling_plan_groups.filter(selling_plan_group => selling_plan_group.app_id === "SKIO" && !selling_plan_group.name.toLowerCase().includes("hidden-") && !selling_plan_group.name.toLowerCase().includes("dynamic box subscription"));
                if (this.availableSellingPlanGroups = filteredSellingPlanGroups.filter(selling_plan_group => selling_plan_group.selling_plans.some(selling_plan => this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id))), this.options?.combine_groups && (this.availableSellingPlanGroups = [{
                        name: this.options?.combined_group_name,
                        selling_plans: this.availableSellingPlanGroups.flatMap(group => group.selling_plans),
                        id: "combined_group",
                        app_id: "SKIO"
                    }]), this.availableSellingPlanGroups?.length) {
                    const urlSelectedSellingPlanId = new URL(window.location.href).searchParams.get("selling_plan");
                    if (this.availableSellingPlanGroups.forEach(group => {
                            const availableSellingPlans = this.getAvailableSellingPlans(group),
                                urlSelectedSellingPlan = availableSellingPlans.find(plan => plan.id == urlSelectedSellingPlanId),
                                nameSelectedSellingPlan = availableSellingPlans.find(plan => plan.name === this.selectedSellingPlan?.name),
                                defaultSellingPlan = this.options?.default_subscription && this.options.default_subscription.trim() !== "" ? availableSellingPlans.find(plan => plan.name.toLowerCase().includes(this.options.default_subscription.toLowerCase())) : null;
                            group.selected_selling_plan = urlSelectedSellingPlan || nameSelectedSellingPlan || defaultSellingPlan || availableSellingPlans[0];
                            const isAnyPlanSelected = urlSelectedSellingPlan || nameSelectedSellingPlan || defaultSellingPlan;
                            group.selected = !!isAnyPlanSelected
                        }), !this.variantChanged && this.options?.start_onetime == !1 || this.product.requires_selling_plan == !0 || urlSelectedSellingPlanId || this.selectedSellingPlan) {
                        let selectedSellingPlanId = (this.availableSellingPlanGroups.find(group => group.selected) || this.availableSellingPlanGroups[0]).selected_selling_plan.id;
                        this.selectSellingPlan(selectedSellingPlanId)
                    } else this.selectSellingPlanGroup(null)
                } else this.selectSellingPlanGroup(null)
            }
            if (changed.has("selectedSellingPlan")) {
                const event = new CustomEvent("skio::update-selling-plan", {
                    bubbles: !0,
                    composed: !0,
                    detail: {
                        variant: this.selectedVariant,
                        sellingPlan: this.selectedSellingPlan,
                        key: this.key
                    }
                });
                this.dispatchEvent(event), this.dispatchEvent(new CustomEvent("change", {
                    detail: {
                        value: this.selectedSellingPlan?.id
                    }
                }))
            }
            this.updateForm(), this.updateExternalPrice(), this.disableUrl || this.updateURLParams(), changed.has("quantity") && this.getRule(), changed.has("cart") && this.getRule(), this.updateExternalElements()
        }
    }
    updateExternalElements() {
        document.querySelectorAll(`[skio-price][skio-key="${this.key}"]`).forEach(el => {
            el.innerHTML = this.price(this.selectedSellingPlan)
        }), document.querySelectorAll("[skio-subscription-content]").forEach(el => {
            el.style.display = this.selectedSellingPlan ? "block" : "none"
        })
    }
    log(...args) {
        args.unshift(`%c[skio plan picker][${this.key}]`, "color: #8770f2;"), console.log.apply(console, args)
    }
    error(...args) {
        args.unshift(`%c [skio plan picker][${this.key}]`, "color: #ff0000"), console.error.apply(console, args)
    }
    appendOrdinalSuffix(num) {
        const j = num % 10,
            k = num % 100;
        return j == 1 && k != 11 ? num + "st" : j == 2 && k != 12 ? num + "nd" : j == 3 && k != 13 ? num + "rd" : num + "th"
    }
    viable() {
        const errors = [];
        return this.querySelector("input[name=selling_plan]") || errors.push("Missing selling plan input"), this.product || errors.push("No product found. Please pass a product or productHandle to the skio-plan-picker component."), this.selectedVariant || errors.push("No variant found. Please pass a product or productHandle to the skio-plan-picker component."), this.form || errors.push('No form found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id".'), this.variantInput || errors.push('No variant input found. Please add a form_id to the plan picker through the Shopify customizer or ensure that the element is in a form that has an input with name="id"'), errors.length == 0 ? !0 : (this.error("Errors", errors), !1)
    }
    getAvailableSellingPlans(group) {
        return group.selling_plans.filter(selling_plan => this.selectedVariant.selling_plan_allocations.some(selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id))
    }
    selectSellingPlanGroup(group) {
        this.selectedSellingPlanGroup = group, this.selectedSellingPlan = group?.selected_selling_plan
    }
    selectSellingPlan(selling_plan_id) {
        const selectedGroup = this.availableSellingPlanGroups.find(group => group.selling_plans.some(plan => plan.id == selling_plan_id)),
            selectedSellingPlan = selectedGroup.selling_plans.find(plan => plan.id == selling_plan_id);
        selectedGroup.selected_selling_plan = selectedSellingPlan, this.selectedSellingPlanGroup = selectedGroup, this.selectedSellingPlan = selectedSellingPlan
    }
    updateExternalPrice() {
        document.querySelectorAll(this.options?.external_price_selector).forEach(el => {
            this.selectedSellingPlan ? el.innerHTML = this.price(this.selectedSellingPlan) : el.innerHTML = this.money(this.selectedVariant.price)
        })
    }
    additionalFrequencyLabel() {
        if (!(!this.options?.additional_frequency_label || this.options?.additional_frequency_label == "")) return unsafeHTML(this.options?.additional_frequency_label)
    }
  // ${this.freeShippingAvailable ? unsafeHTML(`<li>Estimated shipping date Feb 10th</li> <li>Try your first box. Decide later.</li> <li>No commitment. Cancel anytime.</li> <li>Free THRSTY Bottle</li>`) :unsafeHTML(this.options?.additional_subscription_content.replaceAll("[discount]",this.options?.discount_format==="absolute"?this.money(this.discount(this.selectedSellingPlan).absolute):this.discount(this.selectedSellingPlan).percent+"%").replaceAll("[future_price_adjustments]",this.postCheckoutDiscountsText(this.selectedSellingPlan)||""))}
    additionalContentText() {
        if (!(!this.options?.additional_subscription_content || this.options?.additional_subscription_content == "")) return html`
      <div class="group-content-additional">
        ${unsafeHTML(` <li>Save £10 on every box.</li> <li>Switch flavour, skip or cancel anytime.</li> <li>Free THRSTY Bottle</li>`)}
      </div>
    `
    }
    discountText(selling_plan) {
        const discount = this.discount(selling_plan);
        return Object.values(discount).some(value => value === 0 || value === 1 / 0 || value.toString().includes("-")) ? "" : unsafeHTML(this.options?.discount_text.replaceAll("[discount]", this.options?.discount_format === "absolute" ? this.money(discount.absolute) : discount.percent + "%").replaceAll("[future_price_adjustments]", this.postCheckoutDiscountsText(selling_plan) || ""))
    }
    discount(selling_plan) {
        return selling_plan ? this.getDiscountFromPriceAdjustment(selling_plan, selling_plan.price_adjustments[0]) : {
            percent: 0,
            amount: 0
        }
    }
    postCheckoutPriceAdjustments(selling_plan) {
        const {
            price_adjustments
        } = selling_plan;
        return price_adjustments.filter(({
            position
        }) => position !== 1).map(price_adjustment => this.getDiscountFromPriceAdjustment(selling_plan, price_adjustment))
    }
    postCheckoutDiscountsText(sellingPlan = this.selectedSellingPlan) {
        if (!sellingPlan || !this.options?.future_price_adjustments_text || this.future_price_adjustments_text == "") return;
        const postCheckoutPriceAdjustments = this.postCheckoutPriceAdjustments(sellingPlan);
        if (postCheckoutPriceAdjustments.length) return postCheckoutPriceAdjustments.map((discount, index) => this.options?.future_price_adjustments_text.replaceAll("[discount]", this.options?.discount_format === "absolute" ? this.money(discount.absolute) : discount.percent + "%").replaceAll("[order_count]", index + 1).replaceAll("[order_count_ordinal]", this.appendOrdinalSuffix(index + 1)))
    }
    getDiscountFromPriceAdjustment(selling_plan, price_adjustment) {
        const discount = {
            percent: 0,
            amount: 0,
            absolute: 0
        };
        let multiplier = 1;
        if (this.product.selling_plan_groups.find(group => group.selling_plans.some(plan => plan.id == selling_plan.id))?.name === "Prepaid") {
            const str = selling_plan.name,
                intervalDate = /\b\d+\s*(days|weeks|months|years)\b/gi,
                intervalDateMatches = str.match(intervalDate);
            if (intervalDateMatches?.length) {
                const intervals = intervalDateMatches[0].match(/\d+/g);
                multiplier = intervals[0] / (intervals[1] || 1), multiplier = multiplier > 1 ? multiplier : 1
            }
        }
        const price = this.selectedVariant.price,
            compareAtPrice = this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > price ? this.selectedVariant.compare_at_price : price;
        switch (price_adjustment.value_type) {
            case "percentage":
                discount.percent = price_adjustment.value, discount.absolute = Math.round(price * price_adjustment.value / 100), discount.amount = Math.round(price * price_adjustment.value / 100);
                break;
            case "fixed_amount":
                discount.percent = Math.round(price_adjustment.value * 1 / price * 100), discount.absolute = price_adjustment.value, discount.amount = price_adjustment.value;
                break;
            case "price":
                discount.percent = Math.round((compareAtPrice * multiplier - price_adjustment.value) * 1 / (compareAtPrice * multiplier) * 100), discount.absolute = compareAtPrice * multiplier - price_adjustment.value, discount.amount = price - price_adjustment.value;
                break
        }
        return discount
    }
    money(cents, formatString = this.moneyFormat) {
        const placeholderRegex = /{{\s*(\w+)\s*}}/;

        function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
            if (isNaN(number) || number == null) return "0";
            const parts = (number / 100).toFixed(precision).split("."),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
                cents2 = parts[1] ? decimal + parts[1] : "";
            return dollars + cents2
        }
        return formatString.replace(placeholderRegex, (match, placeholder) => {
            switch (placeholder) {
                case "amount":
                    return formatWithDelimiters(cents, 2);
                case "amount_no_decimals":
                    return formatWithDelimiters(cents, 0);
                case "amount_with_comma_separator":
                    return formatWithDelimiters(cents, 2, ".", ",");
                case "amount_no_decimals_with_comma_separator":
                    return formatWithDelimiters(cents, 0, ".", ",");
                case "amount_with_apostrophe_separator":
                    return formatWithDelimiters(cents, 2, "'", ".");
                case "amount_no_decimals_with_space_separator":
                    return formatWithDelimiters(cents, 0, " ");
                case "amount_with_space_separator":
                    return formatWithDelimiters(cents, 2, " ", ",");
                case "amount_with_period_and_space_separator":
                    return formatWithDelimiters(cents, 2, " ", ".");
                default:
                    return match
            }
        })
    }
    price(selling_plan, formatted = !0) {
        return this.rule ? formatted ? this.money(this.selectedVariant.price - this.discount(selling_plan).amount - this.selectedVariant.price * (this.rule.discountAmount / 100)) : this.selectedVariant.price - this.discount(selling_plan).amount - this.selectedVariant.price * (this.rule.discountAmount / 100) : formatted ? this.money(this.selectedVariant.price - this.discount(selling_plan).amount) : this.selectedVariant.price - this.discount(selling_plan).amount
    }
    updateForm() {
        let $sellingPlan = this.querySelector("input[name=selling_plan]");
        $sellingPlan && ($sellingPlan.value = this.selectedSellingPlan ? this.selectedSellingPlan.id : "", $sellingPlan.dispatchEvent(new Event("change")))
    }
    updateURLParams() {
        const url = new URL(window.location.href);
        this.selectedSellingPlan ? (url.searchParams.set("selling_plan", this.selectedSellingPlan.id), window.history.replaceState({}, "", url.href)) : (url.searchParams.delete("selling_plan"), window.history.replaceState({}, "", url.href))
    }
    addToCart(quantity) {
        const items = [{
            id: this.selectedVariant.id,
            quantity,
            ...this.selectedSellingPlan && {
                selling_plan: this.selectedSellingPlan?.id
            }
        }];
        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                items
            })
        }).then(response => response.json()).then(response => {
            this.log("Added item to cart: ", response);
            const event = new CustomEvent("skio::added-to-cart", {
                bubbles: !0,
                composed: !0,
                detail: {
                    response,
                    key: this.key
                }
            });
            this.dispatchEvent(event)
        }).catch(error => {
            this.error(`SKIO ${this.key} error adding item to cart: `, error)
        })
    }
    fetchProduct = handle => fetch(`/products/${handle}.js`).then(response => response.json()).then(product => (this.product = product, this.selectedVariant = product.variants[0], product))
}
customElements.get("skio-plan-picker") || customElements.define("skio-plan-picker", SkioPlanPicker), window && (window.SkioPlanPicker = SkioPlanPicker);